export default __webpack_public_path__ + "static/media/dokumente.a2741e3c.jpg";